import { getPartnerProfilePath } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/_utils/appointment-entity-path';
import { Appointment } from '@/types/appointments.types';
import { addressFormatter } from '@/utils/formatters/format-address';
import { maskPhone } from '@/utils/formatters/phonenumber';

export interface AppointmentLocation {
  socialName: string;
  href?: string;
  address: string;
  phone?: string;
  email?: string;
}

export function getAppointmentLocation(appointment: Pick<Appointment, 'type' | 'partner'>): AppointmentLocation {
  const { partner } = appointment;

  return {
    socialName: partner.socialName,
    href: getPartnerProfilePath(appointment),
    address: addressFormatter(partner.facility, 'full'),
    phone: maskPhone(partner.facility?.contacts?.whatsapp),
    email: partner.facility?.contacts?.email,
  };
}
